
import DoctorsList from '@/components/Departments/common/DoctorsListTemplate2.vue';
import { DepartmentPropDataInterface } from '@/ts/interfaces';
import { defineComponent } from 'vue';

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: 'Psychiatry Doctors',
      queryName: 'Psychiatry',
      teamName: 'Psychiatry team',
    };
  },
  components: { DoctorsList },
});
